const fevaDisclosureViewTemplate = `
<div ng-if="isSubjectToFeva" class="feva-disclosure things-to-know-container col-sm-12 col-md-12 col-xs-12 margin-bottom-200">
    <div class="row">
        <div class="col things-header">
            <span class="em-lightbulb-circle"></span>
            <span role="heading">{{"fevaMessaging.header" | translate}}</span>
        </div>
    </div>
    <div class="row">
        <div class="col things-body">
            <p>{{"fevaMessaging.messageLine1"| translate}}</p>
            <p>{{"fevaMessaging.messageLine2"| translate}}</p>
        </div>
    </div>
</div>
`;
export default fevaDisclosureViewTemplate;
